import * as React from "react";
import { connect } from "react-redux";

import {
  Video as VideoComponent,
  VideoProps,
} from "../../components/Video/Video";

class Video extends React.Component<VideoProps> {
  render() {
    return <VideoComponent {...this.props} />;
  }
}

export default connect(null, {})(Video);
